import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as RouterActions from 'app/store/common-effects/router.effects';
import { oneWebhook } from 'app/store/root/webhooks/webhooks.selectors';
import { WebhookService } from 'core/http/root';
import { selectFirst, to404PageIfNotFound } from 'core/utils/rx-common';
import { defer, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-test-webhook',
  templateUrl: './test-webhook.component.html',
  styleUrls: ['./test-webhook.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TestWebhookComponent implements OnInit, OnDestroy {
  readonly webhookId = this.route.snapshot.params.webhookId;
  private _defaultEventExample = '';
  private _eventExample = '';
  private _testResult = '';
  private _loader = false;
  private _request = new Subscription();
  loadError = false;

  get defaultEventExample(): string {
    return this._defaultEventExample;
  }

  get loader(): boolean {
    return this._loader;
  }

  set loader(value: boolean) {
    this._loader = value;
  }

  get testResult(): string {
    return this._testResult;
  }

  get eventExample(): string {
    return this._eventExample;
  }

  set eventExample(value: string) {
    this._eventExample = value;
  }

  constructor(
    private webhookService: WebhookService,
    private route: ActivatedRoute,
    private store$: Store,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.store$.pipe(
      selectFirst(oneWebhook, { id: this.webhookId }),
      to404PageIfNotFound(this.store$, 'root'),
    ).subscribe((webhook) => {
      this._defaultEventExample = JSON.stringify(webhook.eventExample, null, 2);
      this.eventExample = this.defaultEventExample;
    });
  }

  sendTestRequest(): void {
    this._request.unsubscribe();
    this._request = defer(() => {
      this.loader = true;
      this.loadError = false;
      this.cd.markForCheck();
      return this.webhookService.checkWebhook({ event: JSON.parse(this.eventExample) }, this.webhookId);
    }).pipe(
      finalize(() => {
        this.loader = false;
        this.cd.markForCheck();
      }),
    ).subscribe({
      next: testResult => this._testResult = JSON.stringify(testResult, null, 2),
      error: () => this.loadError = true,
    });
  }

  ngOnDestroy(): void {
    this._request.unsubscribe();
  }

  resetInputForm(): void {
    this.eventExample = this.defaultEventExample;
  }

  goBack(): void {
    this.store$.dispatch(RouterActions.navigateToRoot({ path: ['integration', 'webhooks'] }));
  }
}
